<template>
  <v-layout>
    <v-flex xs12>
    <v-card class="mt-2" width="100%">
      <v-card-title>
      <v-dialog v-model="dialog" max-width="500px" persistent>
        <v-btn color="primary" dark slot="activator" class="mb-2">New Vehicle</v-btn>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-form ref="newVehicle" v-model="newVehicleValid">
                    <v-text-field 
                        label="Vehicle Registration" 
                        v-model="editedItem.VehicleReg"
                        :rules="[v => !!v || 'Vehicle Registration is required']" 
                        required
                        hint = "Vehicle Regs will automatically be uppercased and spaces removed"
                        persistent-hint>
                    </v-text-field>
                    <v-combobox
                        label="Make"
                        v-model="makeSelect"
                        :items="vehicleMakes"
                        item-text="name"
                        item-value="key"
                        combobox
                        clearable></v-combobox>
                    <v-combobox
                        label="Model"
                        v-model="editedItem.Model"
                        :items="modelList"
                        item-text="name"
                        item-value="key"
                        :loading="gettingModels"
                        combobox
                        clearable></v-combobox>
                    <v-text-field
                        label="Year"
                        v-model="editedItem.Year"
                        type="number"></v-text-field>
                    <v-autocomplete
                        label="Customer"
                        v-model="editedItem.Customer"
                        :items="customerList"
                        :rules="[v => !!v || 'Customer is required']" 
                        item-text="name"
                        item-value="key"
                        required></v-autocomplete>
                    <v-autocomplete
                        label="Site"
                        v-model="editedItem.Site"
                        :items="filteredSites"
                        item-text="name"
                        item-value="key"
                        :rules="[v => !!v || 'Site is required']" 
                        required
                        append-outer-icon="mdi-plus"
                        @click:append-outer="siteDialog = true"
                        ></v-autocomplete>
                    <v-dialog v-model="siteDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                        <v-card>
                          <v-toolbar dark color="primary">
                            <v-btn icon dark @click="siteDialog = false">
                              <v-icon>close</v-icon>
                            </v-btn>
                            <v-toolbar-title>Sites</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                              <v-btn dark flat @click="siteDialog = false">Save</v-btn>
                            </v-toolbar-items>
                          </v-toolbar>
                          <v-layout>
                            <sites-view v-if="siteDialog"/>
                          </v-layout>
                        </v-card>
                      </v-dialog>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click.native="save" :disabled="!newVehicleValid">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        <multi-vehicle-dialog :parentCustomer="null" @vehiclesAdded="vehiclesAdded"></multi-vehicle-dialog>
        <bulk-add-vehicle-dialog @vehiclesAdded="vehiclesAdded"></bulk-add-vehicle-dialog>
        <v-btn @click="exportData">Export</v-btn>
        <v-spacer></v-spacer>
        <v-autocomplete
          clearable
          v-model="selectedCustomer"
          label="Select Customer"
          :items="customerList"
          item-text="name"
          item-value="key"
          dense
          hide-details
        >
        </v-autocomplete>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="modifiedVehicles"
        :search="search"
        item-key="id"
        :loading="tableLoading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.friendlyId ? props.item.friendlyId : 'TBC' }}</td>
          <td :style="props.item.VehicleReg ? 'font-style: normal;' : 'font-style: italic;'">{{ (props.item.VehicleReg ? props.item.VehicleReg : props.item.friendlyId ? props.item.friendlyId : 'TBC') | uppercase }} <v-icon v-if="props.item.VehicleReg && duplicateRegs.indexOf(props.item.VehicleReg.toLowerCase().replace(/ /g, '')) > -1" color="red" small>mdi-numeric-2-box-multiple-outline</v-icon></td>
          <td>{{ props.item.CustomerName }}</td>
          <td>{{ props.item.SiteName }}</td>
          <td>{{ props.item.Make }}</td>
          <td>{{ props.item.Model }}</td>
          <td>{{ props.item.Year }}</td>
          <td class="text-xs-right">
            <v-btn icon class="mx-0" @click.stop="editItem(props.item)">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <v-btn icon class="mx-0" @click.stop="deleteItem(props.item)">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card>
    </v-flex>
    <template>
  <v-textarea :hidden="hideExportBox" id="excelInput" v-model="excelInput" label="Excel Data Input"></v-textarea>
</template>
  </v-layout>
</template>

<script>
import { fireStore } from '../../firebase'
import moment from 'moment'
export default {
  data () {
    return {
      siteDialog: false,
      addedFilter: null,
      expanded: false,
      newVehicleValid: false,
      gettingModels: false,
      makeSelect: null,
      vehicleModels: {},
      excelInput: '',
      hideExportBox: true,
      sites: [],
      headers: [
        {
          text: 'Vehicle ID',
          value: 'friendlyId',
          align: 'left'
        },
        {
          text: 'Vehicle Registration',
          value: 'VehicleReg',
          align: 'left'
        },
        {
          text: 'Customer',
          value: 'CustomerName',
          align: 'left'
        },
        {
          text: 'Site',
          value: 'SiteName',
          align: 'left'
        },
        {
          text: 'Make',
          value: 'Make',
          align: 'left'
        },
        {
          text: 'Model',
          value: 'Model',
          align: 'left'
        },
        {
          text: 'Year',
          value: 'Year',
          align: 'left'
        },
        {
          text: 'Actions',
          value: 'Actions',
          align: 'right',
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: 25,
        sortBy: 'friendlyId',
        descending: true
      },
      search: '',
      dialog: false,
      dialogOpened: 0,
      editedIndex: -1,
      selectedCustomer: null,
      tableLoading: false,
      editedItem: {
        VehicleReg: '',
        Year: null
      },
      defaultItem: {
        VehicleReg: ''
      }
    }
  },
  created () {
    // this.getVehicles()
    this.$store.dispatch('fetchVehicles')
    this.$store.dispatch('fetchCustomers')
    this.getSites()
    this.editedItem.Year = new Date().getFullYear()
  },
  computed: {
    vehicles () {
      return this.$store.getters.vehicles
    },
    customerList () {
      return this.$store.getters.customers
    },
    vehicleMakes () {
      let vehicleMakes = []
      for (let v of this.vehicles) {
        if (v.Make && vehicleMakes.indexOf(v.Make) === -1) {
          vehicleMakes.push(v.Make)
        }
      }
      return vehicleMakes
    },
    modelList () {
      let modelList = []
      if (this.makeSelect) {
        for (let v of this.vehicles) {
          if (v.Model && v.Make && this.makeSelect === v.Make && modelList.indexOf(v.Model) === -1) {
            modelList.push(v.Model)
          }
        }
      }
      return modelList
    },
    filteredSites () {
      return this.sites.filter(s => s.customer === this.editedItem.Customer)
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Vehicle' : 'Edit Vehicle'
    },
    customerObj () {
      let obj = {}
      this.customerList.forEach(customer => {
        obj[customer.key] = customer.name
      })
      return obj
    },
    modifiedVehicles () {
      let modifiedVehicles = []
      for (let veh of this.vehicles) {
        if (this.addedFilter && (veh.Added < this.addedFilter || !veh.Added)) {
          continue
        }
        if (this.selectedCustomer && this.selectedCustomer !== veh.Customer) {
          continue
        }
        let siteIndex = this.sites.findIndex(s => veh.Site === s.key)
        if (siteIndex !== -1) {
          veh.SiteName = this.sites[siteIndex].name
        } else {
          veh.SiteName = '----'
        }
        if (this.customerObj[veh.Customer] !== undefined) {
          veh.CustomerName = this.customerObj[veh.Customer]
        } else {
          veh.CustomerName = '----'
        }
        modifiedVehicles.push(veh)
      }
      return modifiedVehicles
    },
    duplicateRegs () {
      let duplicates = []
      let regObj = {}
      this.vehicles.forEach(vehicle => {
        const vehicleReg = vehicle.VehicleReg !== undefined ? vehicle.VehicleReg.toLowerCase().replace(/ /g, '') : ''
        if (regObj[vehicleReg]) {
          duplicates.push(vehicleReg)
        } else {
          regObj[vehicleReg] = 1
        }
      })
      return duplicates
    }
  },
  watch: {
    dialog: function (val) {
      val || this.close()
    },
    siteDialog: function (val) {
      if (!val) {
        this.getSites()
      }
    },
    'editedItem.Customer': function (newVal, oldVal) {
      this.editedItem.Site = null
    }
  },
  methods: {
    exportData () {
      let exportString = ''

      for (const header of this.headers) {
        if (header.text !== 'Actions') {
          exportString += header.text + '\t'
        }
      }

      exportString += 'Added\n'

      for (const v in this.modifiedVehicles) {
        const e = this.modifiedVehicles[v]

        exportString += (e.friendlyId ? e.friendlyId : 'TBC') + '\t'
        exportString += (e.VehicleReg ? e.VehicleReg : e.friendlyId ? e.friendlyId : 'TBC') + '\t'
        exportString += e.CustomerName + '\t'
        exportString += (e.SiteName || '') + '\t'
        exportString += (e.Make || '') + '\t'
        exportString += (e.Model || '') + '\t'
        exportString += (e.Year || '') + '\t'
        exportString += e.Added ? moment(e.Added).format('DD/MM/YYYY') : ''
        exportString += '\n'
      }

      this.excelInput = exportString
      this.hideExportBox = false
      setTimeout(() => {
        document.getElementById('excelInput').select()
        document.execCommand('copy')
        this.hideExportBox = true
        this.excelInput = ''
      }, 20)
    },
    getSites () {
      this.sites = []
      fireStore.collection('Sites')
      .get()
      .then(snap => {
        snap.forEach(doc => {
          this.sites.push({key: doc.id, name: doc.data().Name, customer: doc.data().Customer})
        })
      })
    },
    getVehicles () {
      this.tableLoading = true
      this.vehicles = []
      fireStore.collection('Vehicles')
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let data = doc.data()
            data.id = doc.id
            this.vehicles.push(data)
            if (this.vehicleMakes.includes(data.Make) === false && data.Make !== undefined) {
              this.vehicleMakes.push(data.Make)
            }
            if (((this.vehicleModels[data.Make] && this.vehicleModels[data.Make].includes(data.Model) === false) || this.vehicleModels[data.Make] === undefined) && data.Model !== undefined && data.Make !== undefined) {
              if (this.vehicleModels[data.Make] === undefined) {
                this.vehicleModels[data.Make] = []
              }
              this.vehicleModels[data.Make].push(data.Model)
            }
          })
          this.tableLoading = false
        })
    },
    editItem (item) {
      this.editedIndex = this.vehicles.findIndex(vehicle => {
        return item.key === vehicle.key
      })
      this.makeSelect = item.Make
      this.dialogOpened = 1
      this.editedItem = Object.assign({}, item)
      fireStore.collection('Vehicles').where('VehicleReg', '==', this.editedItem.key)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let data = doc.data()
          data.id = doc.id
          this.vehicles.push(data)
        })
        this.dialog = true
      })
    },

    deleteItem (item) {
      confirm('Are you sure you want to delete this item?') && fireStore.collection('Vehicles').doc(item.key).delete()
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      this.editedItem.VehicleReg = this.editedItem.VehicleReg.toUpperCase().replace(/\s/g, '')
      let vIndex = this.vehicles.findIndex((v) => {
        return this.editedItem.VehicleReg === v.VehicleReg ? v.VehicleReg.replace(/ /g, '').toUpperCase() : null
      })
      if (vIndex > -1) {
        return alert('That vehicle is already in the system, please try a different reg.')
      }
      this.editedItem.Make = this.makeSelect || null
      if (this.editedIndex > -1) {
        fireStore.collection('Vehicles').doc(this.editedItem.key).set(this.editedItem, {merge: true})
        .then(() => {
          this.close()
        })
      } else {
        this.editedItem.Added = Date.now()
        fireStore.collection('Vehicles').add(this.editedItem)
        .then((docRef) => {
          this.close()
        })
      }
    },
    vehiclesAdded (vehicleArr) {
      // vehicleArr.forEach(vehicle => {
      //   this.vehicles.push(vehicle)
      // })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Vehicle.vue?41b851f6